// No Leaflet import here: this file must run under Bun without a DOM.
export const GTA_TRANSFORM: [number, number, number, number] = [0.02072, 117.3, -0.0205, 172.8];

export function readTransform(env: string | undefined): [number, number, number, number] {
  if (!env) return GTA_TRANSFORM;
  const parts = env.split(',').map((p) => Number(p.trim()));
  if (parts.length !== 4 || parts.some((n) => Number.isNaN(n))) return GTA_TRANSFORM;
  return parts as [number, number, number, number];
}
